import React, {PropTypes} from 'react';
import Submitting from 'shared/Submitting.jsx';
import VirtualEntryBowler from './VirtualEntryBowler.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const VirtualEntryBowlerList = ({
  zindexvalue,
  virtualEventId,
  source,
  bowlers,
  virtualBowlers,
  submitting,  
  showCalculatedDivisionToCaptain,
  onVirtualEntryBowlerChange,
  onVirtualEntryRemoveClick,
  onCancelClick,
  onUpdateClick,
  assignedByOtherCaptain
}) => (
  <div className="panel panel-default animated fadeIn" 
    style={{position: 'relative', zIndex: zindexvalue}}>
    <div className="panel-body">
      <ErrorListContainer />
      <div className="contact-card-wrapper">
        {source.map((item, index) => (
          <div key={index}>
            { item && item.id && (item.id.length < 36 || item.id.toString().length < 36) ? 
              <div className="text-right">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => onVirtualEntryRemoveClick(virtualEventId, item.id)}
                ><i className="fa fa-trash-o" /> {`Remove`}</button>
              </div> 
            : null }
            <VirtualEntryBowler
              {...item}
              bowlers={bowlers.filter(b => {
                return virtualBowlers.length > 0 
                  ? item.bowlerId == b.id || !virtualBowlers.some(vb => {return vb.bowlerId == b.id;}) && !source.some(s => {return s.bowlerId == b.id;})
                  : item.bowlerId == b.id || !source.some(s => {return s.bowlerId == b.id;});              
              })}
              position={index + 1}
              onBowlerChange={onVirtualEntryBowlerChange}
              divisionName={item.divisionName}
              showCalculatedDivisionToCaptain={showCalculatedDivisionToCaptain}
            />
          </div>
        ))}
      </div>
      <br />
      <div className="form-group text-right">
        <button
          type="button"
          className="btn btn-link"
          disabled={submitting}
          onClick={onCancelClick}
        >Cancel</button>
        {` `}
        <button
          type="button"
          className="btn btn-primary btn-lg"
          disabled={submitting || assignedByOtherCaptain}
          onClick={() => onUpdateClick(virtualEventId)}
        >{submitting ? <Submitting /> : <i className="fa fa-floppy-o" />} {`Update`}</button>
      </div>
    </div>
  </div>
);

VirtualEntryBowlerList.propTypes = {
  zindexvalue: PropTypes.number,
  virtualEventId: PropTypes.string.isRequired,
  source: PropTypes.arrayOf(PropTypes.object),
  bowlers: PropTypes.arrayOf(PropTypes.object),
  virtualBowlers: PropTypes.arrayOf(PropTypes.object),
  submitting: PropTypes.bool,
  onVirtualEntryBowlerChange: PropTypes.func,
  onVirtualEntryRemoveClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onUpdateClick: PropTypes.func,
  showCalculatedDivisionToCaptain: PropTypes.bool,
  assignedByOtherCaptain: PropTypes.bool
};

VirtualEntryBowlerList.defaultProps = {
  source: [],
  bowlers: [],
  virtualBowlers: []
};

export default VirtualEntryBowlerList;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/VirtualEntryBowlerList.jsx